import axiosConfig from "../axios.config";
const axios = require('axios');

export const $http = axios.create(axiosConfig); 